import type { Router } from '@angular/router';

import type { AuthService } from './auth.service';

export const SESSION_EXPIRED_QUERY = 'session_expired';

/** Prevent a burst of parallel 401s from firing multiple login redirects. */
let redirectInFlight = false;

/**
 * Clear a rejected session and send the user to the login intro screen.
 * The intro owns the Auth0 redirect — same flow as the legacy app.
 */
export async function redirectToLoginAfterAuthFailure(
  auth: AuthService,
  router: Router,
): Promise<void> {
  if (redirectInFlight) return;

  const onCallback =
    typeof window !== 'undefined' && window.location.pathname.endsWith('/login/callback');
  if (onCallback) return;

  if (router.url.startsWith('/login')) return;

  redirectInFlight = true;

  try {
    await auth.clearSessionLocally();
  } catch (err) {
    console.warn('[auth] clearSessionLocally failed', err);
  }

  const returnTarget =
    router.url && router.url !== '/login' && !router.url.startsWith('/login?') ? router.url : '/';

  await router.navigateByUrl(sessionExpiredLoginUrl(returnTarget), { replaceUrl: true });

  redirectInFlight = false;
}

export function sessionExpiredLoginUrl(returnTarget: string): string {
  const loginPath =
    returnTarget === '/' ? '/login' : `/login?redirect_url=${encodeURIComponent(returnTarget)}`;

  const separator = loginPath.includes('?') ? '&' : '?';
  return `${loginPath}${separator}${SESSION_EXPIRED_QUERY}=1`;
}
